// Module
var code = "<div title=\"{{vm.mapped.join(', ')}}\" class=\"user-fields\"> <span ng-repeat=\"field in vm.mapped\" class=\"logbook-label\"> {{field}} </span> </div>";
// Exports
module.exports = code;